export default function clone(element) {
  return element.cloneNode(true);
}